import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import PlayButton from './ui/PlayButton';
import LoadingBar from './ui/LoadingBar';
import ListFilter from './filters/ListFilter';
import PaginationButtons from './PaginationButtons';
import NoResults from './ui/NoResults';
import ListHeader from './ui/ListHeader';

import config from './../config';
import helpers from './../lib/helpers';

class ProjectEntryList extends Component {
	constructor(props) {
		super(props);

		this.state = {
			data: null,
			nextUrl: null,
			previousUrl: null,
			resultCount: 0,
			loading: true
		}
	}

	componentDidMount() {
		this.fetchData();
	}

	componentDidUpdate(prevProps, prevState) {
		if (this.props.searchParams != prevProps.searchParams ||
			this.props.locationId != prevProps.locationId ||
			this.props.folkloreId != prevProps.folkloreId ||
			this.props.personId != prevProps.personId ||
			this.props.audioId != prevProps.audioId
		) {
			this.fetchData();
		}
	}

	fetchData() {
		this.setState({
			loading: true,
			data: null
		});

		let urlParams = ['limit=500'];

		if (this.props.bundle) {
			urlParams.push('bundle='+this.props.bundle);
		}

		if (this.props.locationId) {
			urlParams.push('location='+this.props.locationId);
		}

		if (this.props.folkloreId) {
			urlParams.push('folklore='+this.props.folkloreId);
		}

		if (this.props.personId) {
			urlParams.push('person='+this.props.personId);
		}

		if (this.props.audioId) {
			urlParams.push('audio='+this.props.audioId);
		}

		helpers.fetch(config.apiRoot+'/api/projectentries/?'+urlParams.join('&'), (json) => {
			if (json) {
				this.setState({
					data: json.results,
					nextUrl: json.next,
					previousUrl: json.previous,
					resultCount: json.count
				});

				if (this.props.onResponse) {
					this.props.onResponse(json.results);
				}
			}
			this.setState({
				loading: false
			});
		});
	}

	render() {
		let data = this.state.data;

		return (
			<div className={'position-relative '+(this.props.className || '')+(this.state.loading ? ' loading' : '')}>
				<LoadingBar />
				{
					data && data.length > 0 &&
					<React.Fragment>
						{
							this.props.children
						}

						<ListHeader resultCount={this.state.resultCount} />

						<table className="table">
							<thead>
								<tr>
									<th>Titill</th>
									<th>Verkefni</th>
								</tr>
							</thead>
							<tbody>
								{
									data.map((item, index) => <tr key={index}>
										<td>
											{
												<Link className={this.props.selectedEntry && this.props.selectedEntry == item.id ? 'font-weight-bold' : ''} to={helpers.routerUrls['projectentry']+item.id}>{item.title}</Link>
											}
										</td>
										<td>
											{
												<Link to={helpers.routerUrls['project']+item.project.id}>{item.project.title}</Link>
											}
										</td>
									</tr>)
								}
							</tbody>
						</table>
						{
							this.state.resultCount > config.pageSize &&
							<PaginationButtons resultCount={this.state.resultCount}
								previousUrl={this.state.previousUrl}
								nextUrl={this.state.nextUrl} />
						}
					</React.Fragment>
				}
				{
					data && data.length == 0 && !this.state.loading &&
					<NoResults />
				}
			</div>
		)
	}
}

export default withRouter(ProjectEntryList);
